document.addEventListener('click', async function (e) {
    const button = e.target.closest('.order_custom, #pre_order_custom');
    if (button) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const qtyInput = document.querySelector('.quantity__input');
      if (!qtyInput) return;

      const variantId = qtyInput.getAttribute('data-quantity-variant-id');
      const quantity = parseInt(qtyInput.value, 10);
      if (!variantId || isNaN(quantity)) return;

      // get the text of the button
      const buttonText = button.querySelector('span.pre-order-2-button').textContent.trim();
      button.disabled = true;

      try {
        // Check if product already exists in cart
        const cartResponse = await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() });
        const currentCart = await cartResponse.json();
        
        // Find existing item with same variant ID
        const existingItemIndex = currentCart.items.findIndex(item => item.variant_id === parseInt(variantId));
        const existingItem = existingItemIndex !== -1 ? currentCart.items[existingItemIndex] : null;
        
        // Prepare sections to update
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        let body;
        if (existingItem) {
          // Update existing item
          body = JSON.stringify({
            line: existingItemIndex + 1, // Shopify uses 1-based indexing
            quantity: existingItem.quantity + quantity,
            properties: {
              [buttonText]: existingItem.quantity + quantity
            },
            sections: sectionsToBundle,
            sections_url: window.location.pathname
          });
        } else {
          // Add new item
          body = JSON.stringify({
            items: [{ 
              id: parseInt(variantId), 
              quantity,
              properties: {
                [buttonText]: quantity
              }
            }],
            sections: sectionsToBundle,
            sections_url: window.location.pathname
          });
        }

        // Use theme route to add/update cart
        const endpoint = existingItem ? `${FoxTheme.routes.cart_change_url}` : `${FoxTheme.routes.cart_add_url}`;
        const response = await fetch(endpoint, { 
          ...FoxTheme.utils.fetchConfig('javascript'), 
          body: body 
        });
        const parsedState = await response.json();
        
        if (parsedState.status) {
          console.error('Error adding to cart:', parsedState.description);
          return;
        }

        // Get updated cart state
        const updatedCartResponse = await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() });
        const cartJson = await updatedCartResponse.json();
        
        // Merge parsedState sections with cart if they exist
        if (parsedState.sections) {
          cartJson.sections = parsedState.sections;
        }

        // Publish cart update event
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          try {
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
              cart: cartJson 
            });
          } catch (error) {
            console.warn('Cart update event error:', error);
            // Continue with showing cart drawer even if event fails
          }
        }

        // Show cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.show();
        }

        // Update document classes
        document.documentElement.classList.add('cart-has-items');

        // Dispatch product added event
        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            detail: {
              product: parsedState,
            },
          })
        );
      } catch (err) {
        console.error('Error adding to cart:', err);
      } finally {
        // Restore the button
        button.disabled = false;
      }
    }
  }, true);